(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    class NamaslayProductDetails extends HTMLElement {
    #observer = new ResizeObserver(() => this.#updateSticky());

    connectedCallback() {
      const content = this.firstElementChild;
      if (!content) return;

      this.#observer.observe(content);
      const viewport = this.closest('.page-wrapper');
      if (viewport) this.#observer.observe(viewport);
      const header = document.getElementById('header-component');
      if (header) this.#observer.observe(header);
      window.addEventListener('resize', this.#updateSticky);
      this.#updateSticky();
    }

    disconnectedCallback() {
      this.#observer.disconnect();
      window.removeEventListener('resize', this.#updateSticky);
    }

    #updateSticky = () => {
      const content = this.firstElementChild;
      if (!content) return;

      const styles = getComputedStyle(this);
      const headerHeight = Math.max(
        parseFloat(styles.getPropertyValue('--header-height')) || 0,
        parseFloat(styles.getPropertyValue('--sticky-header-offset')) || 0
      );
      const viewport = this.closest('.page-wrapper');
      const viewportHeight = Math.min(window.innerHeight, viewport?.clientHeight || window.innerHeight);
      this.toggleAttribute('data-details-overflow', content.getBoundingClientRect().height > viewportHeight - headerHeight);
    };
  }

  if (!customElements.get('namaslay-product-details')) {
    customElements.define('namaslay-product-details', NamaslayProductDetails);
  }
  } catch(e) { console.error(e); }
})();

})();
